export default __webpack_public_path__ + "/dist/images/italian-contentimg-2.png";